export const getSubscriptionErrorQuery = `
  query($errorCode: String) {
    getSubscriptionErrors(errorCode: $errorCode) {
      subscriptionId
      contactId
      planId
      status
      renewalDate
      errorType
      errorCode
      errorDescription
    }
  }
`;